import {
  PAYOFF_COUPON_BARRIER_LEVEL, PAYOFF_COUPON_BARRIER_LOWER_LEVEL,
  PAYOFF_COUPON_BARRIER_STEP_SIZE,
  PAYOFF_COUPON_BARRIER_TYPE, PAYOFF_COUPON_BARRIER_UPPER_LEVEL,
  PAYOFF_COUPON_LOWER_BARRIER_STEP_SIZE,
  PAYOFF_COUPON_UPPER_BARRIER_STEP_SIZE,
  SUMMARY_PRODUCT_TYPE,
} from './product-capture-field-selectors.consts';

import { FCSelector } from '../../model/form-config.interface';
import {ProductTypeEnum} from "../../../product-capture/model/enums/product-capture.enums";

export const COUPON_BARRIER_TYPE: FCSelector = {
  formControlNames: [PAYOFF_COUPON_BARRIER_TYPE],
  options: [
    {
      id: 'FLAT',
      label: 'Flat',
      effects: [
        {
          formControlNames: [
            PAYOFF_COUPON_BARRIER_STEP_SIZE,
          ],
          hidden: true,
        },
        {
          formControlNames: [
            PAYOFF_COUPON_BARRIER_LEVEL,
          ],
          hidden: false,
        }
      ],
      concatFieldRules: [
        {
          formControlNames: [SUMMARY_PRODUCT_TYPE],
          options: [
            {
              id: ProductTypeEnum.RANGE_ACCRUAL,
              effects: [
                {
                  formControlNames: [
                    PAYOFF_COUPON_BARRIER_STEP_SIZE,
                    PAYOFF_COUPON_BARRIER_LEVEL,
                    PAYOFF_COUPON_LOWER_BARRIER_STEP_SIZE,
                    PAYOFF_COUPON_UPPER_BARRIER_STEP_SIZE,
                  ],
                  hidden: true,
                  readOnly: true,
                  selectValues: [null]
                },
                {
                  formControlNames: [
                    PAYOFF_COUPON_BARRIER_UPPER_LEVEL,
                    PAYOFF_COUPON_BARRIER_LOWER_LEVEL
                  ],
                  hidden: false,
                  readOnly: false
                }
              ]
            }
          ]
        }
      ]
    },
    {
      id: 'STEPPED',
      label: 'Stepped',
      effects: [
        {
          formControlNames: [
            PAYOFF_COUPON_BARRIER_STEP_SIZE,
          ],
          hidden: false,
        },
      ],
      concatFieldRules: [
        {
          formControlNames: [SUMMARY_PRODUCT_TYPE],
          options: [
            {
              id: ProductTypeEnum.RANGE_ACCRUAL,
              effects: [
                {
                  formControlNames: [
                    PAYOFF_COUPON_BARRIER_STEP_SIZE,
                    PAYOFF_COUPON_BARRIER_LEVEL
                  ],
                  hidden: true,
                  readOnly: true,
                  selectValues: [null]
                },
                {
                  formControlNames: [
                    PAYOFF_COUPON_LOWER_BARRIER_STEP_SIZE,
                    PAYOFF_COUPON_UPPER_BARRIER_STEP_SIZE,
                    PAYOFF_COUPON_BARRIER_UPPER_LEVEL,
                    PAYOFF_COUPON_BARRIER_LOWER_LEVEL
                  ],
                  hidden: false,
                  readOnly: false
                }
              ]
            }
          ]
        }
      ]
    },
    {
      id: 'CUSTOM',
      label: 'Custom',
      effects: [{
        formControlNames: [
          PAYOFF_COUPON_BARRIER_STEP_SIZE,
          PAYOFF_COUPON_BARRIER_LEVEL
        ],
        hidden: true
      }],
      concatFieldRules: [
        {
          formControlNames: [SUMMARY_PRODUCT_TYPE],
          options: [
            {
              id: ProductTypeEnum.RANGE_ACCRUAL,
              effects: [
                {
                  formControlNames: [
                    PAYOFF_COUPON_BARRIER_STEP_SIZE,
                    PAYOFF_COUPON_BARRIER_LEVEL,
                    PAYOFF_COUPON_LOWER_BARRIER_STEP_SIZE,
                    PAYOFF_COUPON_UPPER_BARRIER_STEP_SIZE,
                    PAYOFF_COUPON_BARRIER_UPPER_LEVEL,
                    PAYOFF_COUPON_BARRIER_LOWER_LEVEL
                  ],
                  hidden: true,
                  readOnly: true,
                  selectValues: [null]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
};
